import { styled } from '@mui/styles';
import Color from 'color';
import React from 'react';

const CoverageSubgroupTitle = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

export default CoverageSubgroupTitle;

const Container = styled('i')(({ theme }) => {
  return {
    backgroundColor: Color(theme.palette.background.default)
      .lighten(theme.palette.mode === 'dark' ? 0.5 : 0.05)
      .toString(),
    width: '100%',
    paddingLeft: '1.35rem',
    display: 'block',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    textDecoration: 'italic',
    fontWeight: 600,
  };
});
